export function readScheduleState(query = {}, now = new Date()) {
  const month = typeof query.scheduleMonth === 'string' && /^(\d{4})-(0[1-9]|1[0-2])$/.exec(query.scheduleMonth);
  const selectedYear = month && Number(month[1]) >= 1000 ? Number(month[1]) : now.getFullYear();
  const selectedMonth = month && Number(month[1]) >= 1000 ? Number(month[2]) - 1 : now.getMonth();
  const prefix = selectedYear + '-' + String(selectedMonth + 1).padStart(2, '0');
  const date = typeof query.scheduleDate === 'string' ? query.scheduleDate : '';
  const day = Number(date.slice(-2));
  const validDate = /^\d{4}-\d{2}-\d{2}$/.test(date) && date.startsWith(prefix + '-') && day >= 1 && day <= new Date(selectedYear, selectedMonth + 1, 0).getDate();
  return { selectedYear, selectedMonth, selectedDate: validDate ? date : '', view: query.scheduleView === 'calendar' ? 'calendar' : 'agenda' };
}

export function scheduleQuery(state) {
  return {
    scheduleMonth: state.selectedYear + '-' + String(state.selectedMonth + 1).padStart(2, '0'),
    scheduleDate: state.selectedDate || undefined,
    scheduleView: state.view
  };
}
